<template>
    <div class="banner_head p-1 m-0">
        <div class="d-flex flex-column align-items-center justify-content-center flex-banner mt-3">
            <h2 class="text-banner text_banner_title">Cómo participar en la plataforma de subastas</h2>
            <h6 class="text-banner text_banner_cta mt-5 fw-normal">Te explicamos todo lo que necesitás saber para ser parte del mundo
            <span class="fw-bold">Adrián Mercado Subastas.</span></h6>
        </div>
            <img  class=" d-flex flex-banner flex_img" src="@/assets/img/illustrations/avatar_con_martillero.png" />
    </div>
    <div class="container">
        <div class="row mt-5">
            <div class="col-sm-6 col-12 align-items-center justify-content-center">
                <div class="card flex-cont">
                    <div class="card-body d-flex  flex-column  align-items-center justify-content-center card-instrucciones">
                        <h4 class="texto_instrucciones texto_con_martillero"><img class="me-2" src="@/assets/img/icons/online.svg" alt="">Subasta en vivo</h4>
                        <router-link :to="{name:'InstruccionesConMartillero'}">
                        <button class="btn btn-primary boton_instrucciones mt-3">¿Cómo funciona?</button>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-12 align-items-center justify-content-center mt-5 mt-md-0">
                <div class="card flex-cont">
                    <div class="card-body d-flex flex-column  align-items-center justify-content-center card-instrucciones">
                        <h4 class="texto_instrucciones texto_sin_martillero"><img class="me-2" src="@/assets/img/icons/click.svg" alt="">Subasta</h4>
                        <router-link :to="{name:'InstruccionesSinMartillero'}">
                            <button class="btn btn-soft-green boton_instrucciones mt-3">¿Cómo funciona?</button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.banner_head {
    background-color: #375DBF;
    display:flex !important;
    min-width: 100% !important;
    flex-flow: row nowrap !important;
    justify-content: space-around !important;
    align-items: center !important;
}

.text-banner {
    color: white !important;
}
.text_banner_title{
    font-size: xx-large;
}
.text_banner_cta{
    font-size: large;
}
.flex-banner{
    min-height: 400px;
    max-width: 500px;
}
.flex_img{
     object-fit: contain;
  max-height: 550px;
  width: 100%;
  height: auto;
  max-width: 300px; 
}

.texto_instrucciones {
    font-weight: normal;
    font-size:xx-large;
}
.boton_instrucciones{
    width:280px;
    border-radius: 2px !important;
}
.card-instrucciones {
    min-height: 280px;
}

.flex-cont {
    max-width: 500px;
    min-width: 280px;
    margin-left: auto;
    margin-right: auto;
}
.texto_con_martillero{
    color:#375DBF !important;
}
.texto_sin_martillero{
    color:#006C4C !important;
    font-weight: 500;
    leading-trim: both; 
}
@media (max-width: 800px) {

    .texto_instrucciones {
         font-size:large;
    }
    .text_banner_title{
    font-size:x-large;
    }
    .text_banner_cta{
    font-size: large;
    }
    .flex-banner {
        max-width: 300px;
     }
      .flex_img {
    max-width: 180px;
    max-height: 360px;
  }
}

@media (max-width: 500px) {
    
    .text_banner_title{
    font-size: large;
    }
    .text_banner_cta{
    font-size: medium;
    }
    .flex-banner {
        max-width: 200px;
     }
      .flex_img {
    max-width: 140px;
    max-height: 280px;
  }
}
</style>